var AuthClientPersistenceOptions;
(function (AuthClientPersistenceOptions) {
    AuthClientPersistenceOptions["NONE"] = "none";
    AuthClientPersistenceOptions["LOCAL_STORAGE"] = "localStorage";
    AuthClientPersistenceOptions["SESSION_STORAGE"] = "sessionStorage";
})(AuthClientPersistenceOptions || (AuthClientPersistenceOptions = {}));
var OAuthGrantTypes;
(function (OAuthGrantTypes) {
    OAuthGrantTypes["AUTH_CODE"] = "authorization_code";
    OAuthGrantTypes["REFRESH_TOKEN"] = "refresh_token";
    OAuthGrantTypes["PASSWORD"] = "password";
})(OAuthGrantTypes || (OAuthGrantTypes = {}));
var OAuthStatusTypes;
(function (OAuthStatusTypes) {
    OAuthStatusTypes["IDLE"] = "idle";
    OAuthStatusTypes["PENDING"] = "pending";
    OAuthStatusTypes["ERROR"] = "error";
    OAuthStatusTypes["AUTHENTICATED"] = "authenticated";
})(OAuthStatusTypes || (OAuthStatusTypes = {}));

/**
 * @param {string|string[]} namespace
 * @param {Window|{}} globalObj
 * @return {<T>|undefined}
 */
function getRegisteredGlobal(namespace, globalObj) {
    const target = (Array.isArray(namespace) ? namespace : namespace.split(".")).reduce((prev, curr) => prev === null || prev === undefined ? undefined : prev[curr], globalObj || window);
    return typeof target === "undefined" ? undefined : target;
}

const globalNamespaceBase = "trumpf";
/**
 * @param {*} obj
 * @param {string|string[]} namespace
 * @param {Window|{}} globalObj
 * @throws Error
 */
function registerGlobal(obj, namespace, globalObj) {
    const tree = Array.isArray(namespace)
        ? namespace
        : namespace.split(".");
    if (tree[0] !== globalNamespaceBase) {
        throw new Error("Invalid namespace");
    }
    let current = globalObj || window;
    tree.forEach((part, index) => {
        if (index === tree.length - 1) {
            current[part] = obj;
        }
        else {
            current[part] = current[part] || {};
            current = current[part];
        }
    });
}

const BASE_NS = "trumpf.ux.authClient";
const DEFAULT_CLIENT_SCOPE = "global";
const DEFAULT_CLIENT_NS = BASE_NS + "." + DEFAULT_CLIENT_SCOPE;
const DEFAULT_CLIENT_PERSISTENCE = AuthClientPersistenceOptions.NONE;
const defaultAuthClientConfig = {
    namespace: DEFAULT_CLIENT_NS,
    persistenceType: DEFAULT_CLIENT_PERSISTENCE,
};
/** @type string ID of the OP iframe */
const OP_IFRAME_ID = "ux-oauth-OP-iframe";
/** @type string ID of the RP iframe */
const RP_IFRAME_ID = "ux-oauth-RP-iframe";
/** @type number Default interval time for session polling */
const RP_POLL_INTERVAL = 2000;
/** @type string Template for the RP iframe src */
const RP_IFRAME_SRCDOC_TPL = `<script type="text/javascript">
    window.poll = function () {
        var opIframe = window.parent.document.querySelector("iframe#OP_IFRAME_ID");
        if (opIframe && opIframe.contentWindow) {
            opIframe.contentWindow.postMessage("OP_IFRAME_MESSAGE", "OP_IFRAME_ORIGIN");
        }
    };
</script>`;

const strToBuffer = (str) => {
    const arrayBuffer = new ArrayBuffer(str.length);
    const uintArray = new Uint8Array(arrayBuffer);
    uintArray.forEach((_, i) => {
        uintArray[i] = str.charCodeAt(i);
    });
    return uintArray;
};
const base64UrlEncode = (str) => {
    return window
        .btoa(str)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
};
const getQueryString = (params) => {
    const queryParams = [];
    Object.entries(params).forEach(([key, value]) => {
        if (key === "url")
            return;
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParams.length > 0 ? queryParams.join("&") : "";
};
const getQueryParameter = (name, url) => {
    var _a;
    if (url === void 0) { url = ((_a = window.top) === null || _a === void 0 ? void 0 : _a.location.href) || window.location.href; }
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
const getUrlOrigin = (url) => {
    const regex = new RegExp("^(https?:\\/\\/[^\\/?]+)");
    const results = regex.exec(url);
    if (!results)
        return "";
    return results[1];
};
const getRandomString = (size = 45) => {
    const unreserved = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let randomString = "";
    // @ts-ignore
    const crypto = window.crypto || window["msCrypto"];
    if (crypto) {
        const bytes = new Uint8Array(size);
        crypto.getRandomValues(bytes);
        const numbers = [];
        bytes.forEach((x, i) => {
            numbers[i] = unreserved.charCodeAt(x % unreserved.length);
        });
        randomString = String.fromCharCode.apply(null, numbers);
    }
    else {
        while (0 < size--) {
            randomString +=
                unreserved[Math.floor(Math.random() * unreserved.length) | 0];
        }
    }
    return randomString;
};
const getCodeVerifier = () => {
    return base64UrlEncode(getRandomString(43));
};
const getCodeChallenge = async (codeVerifier) => {
    try {
        const digest = await crypto.subtle.digest("SHA-256", strToBuffer(codeVerifier));
        const digestBase64 = String.fromCharCode(...Array.from(new Uint8Array(digest)));
        return base64UrlEncode(digestBase64);
    }
    catch (_a) {
        return codeVerifier;
    }
};
const getJWTPayload = (token) => {
    if (!token || !token.length)
        return null;
    const base64Url = token.split(".")[1];
    if (!base64Url)
        return null;
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    try {
        return JSON.parse(window.atob(base64));
    }
    catch (error) {
        return null;
    }
};
const detectTokenExpirationTime = (data) => {
    if (data.expires_at) {
        return data.expires_at;
    }
    const jwt = getJWTPayload(data.id_token || null);
    if (jwt) {
        if (typeof jwt.exp === "number") {
            return jwt.exp;
        }
        if (typeof jwt.iat === "number" && data.expires_in > 0) {
            return jwt.iat + data.expires_in;
        }
    }
    return undefined;
};
const getBaseUrl = (url) => {
    if (typeof url !== "string")
        return null;
    const matches = /(https?:\/\/)([^?]+)(.*)/.exec(url);
    if (matches !== null) {
        return `${matches[1]}${matches[2]}`;
    }
    return null;
};
const getUrlOrCurrent = (url) => {
    if (typeof url === "string" && /^https?:\/\//.test(url)) {
        return url;
    }
    return window.top.location.href;
};

class AuthClient {
    constructor(options) {
        this.accessToken = null;
        this.authData = null;
        this.observers = [];
        this.config = Object.assign(Object.assign({}, defaultAuthClientConfig), options);
        this.init();
    }
    init() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        const storedValue = storage
            ? storage.getItem(namespace)
            : null;
        if (storedValue) {
            try {
                const storedData = JSON.parse(storedValue);
                if (storedData.access_token) {
                    this.accessToken = storedData.access_token;
                    this.authData = storedData;
                    const exp = detectTokenExpirationTime(storedData) || 0;
                    if (exp > 0) {
                        if (exp > Math.floor(new Date().getTime() / 1000)) {
                            this.authData.expires_at = exp;
                        }
                        else {
                            this.accessToken = null;
                            this.authData = null;
                        }
                    }
                }
            }
            catch (_a) {
                // Invalid JSON string
            }
            this.updateStorage();
        }
    }
    getStorage() {
        switch (this.config.persistenceType) {
            case AuthClientPersistenceOptions.LOCAL_STORAGE:
                return window.localStorage;
            case AuthClientPersistenceOptions.SESSION_STORAGE:
                return window.sessionStorage;
            default:
                return null;
        }
    }
    updateStorage() {
        const { namespace } = this.config;
        const storage = this.getStorage();
        if (storage === null) {
            return;
        }
        const data = this.authData
            ? this.authData
            : this.accessToken
                ? { access_token: this.accessToken }
                : null;
        if (!data || !data.access_token) {
            storage.removeItem(namespace);
            return;
        }
        const jsonString = JSON.stringify(data);
        storage.setItem(namespace, jsonString);
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this.accessToken);
            }
            catch (_a) {
                // Catch errors silently
            }
        });
    }
    getAccessToken() {
        return this.accessToken;
    }
    setAccessToken(token) {
        if (!token || !token.length) {
            return false;
        }
        if (token === this.accessToken) {
            return true;
        }
        this.accessToken = token;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
        return true;
    }
    deleteAccessToken() {
        if (this.accessToken === null)
            return;
        this.accessToken = null;
        this.authData = null;
        this.updateStorage();
        this.notifyObservers();
    }
    getTokenData() {
        return this.authData;
    }
    getTokenExpiration() {
        return this.authData
            ? detectTokenExpirationTime(this.authData)
            : undefined;
    }
    setTokenData(data) {
        if (!data ||
            !data.access_token ||
            data.access_token === this.accessToken) {
            return;
        }
        this.authData = data;
        this.accessToken = data.access_token;
        if (!this.authData.expires_at) {
            const exp = detectTokenExpirationTime(data) || 0;
            if (exp > 0) {
                this.authData.expires_at = exp;
            }
        }
        this.updateStorage();
        this.notifyObservers();
    }
    getRefreshToken() {
        return this.authData ? this.authData.refresh_token || null : null;
    }
    getIdToken() {
        return this.authData ? this.authData.id_token || null : null;
    }
    getIdTokenPayload() {
        return getJWTPayload(this.getIdToken());
    }
    subscribe(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
}

/**
 * @param {AuthClientOptions|string|undefined} scopeOrOptions
 * @return {AuthClientInstance}
 */
function getAuthClient(scopeOrOptions) {
    let namespace = DEFAULT_CLIENT_NS;
    let persistenceType = DEFAULT_CLIENT_PERSISTENCE;
    if (scopeOrOptions) {
        if (typeof scopeOrOptions === "string") {
            namespace = BASE_NS + "." + scopeOrOptions;
        }
        else {
            if (scopeOrOptions.namespace) {
                namespace = scopeOrOptions.namespace;
            }
            else if (scopeOrOptions.globalNamespace) {
                // support for deprecated globalNamespace
                namespace = scopeOrOptions.globalNamespace;
            }
            if (scopeOrOptions.persistenceType) {
                persistenceType = scopeOrOptions.persistenceType;
            }
        }
    }
    let client = getRegisteredGlobal(namespace, window);
    if (client === undefined) {
        client = new AuthClient({
            namespace,
            persistenceType,
        });
        registerGlobal(client, namespace);
    }
    return client;
}

var TrumpfEnvNames;
(function (TrumpfEnvNames) {
    TrumpfEnvNames["PROD"] = "prod";
    TrumpfEnvNames["QA"] = "qa";
})(TrumpfEnvNames || (TrumpfEnvNames = {}));

const nsEnvName = "trumpf.ux.env.name";

/**
 * @return {"prod"|"qa"} the current environment
 */
function getEnv() {
    return getRegisteredGlobal(nsEnvName) || TrumpfEnvNames.PROD;
}

/**
 * @param {"prod"|"qa"} env
 * @return {boolean} true if a valid env was passed in
 */
function setEnv(env) {
    if (typeof env === "undefined")
        return false;
    const currentEnv = getRegisteredGlobal(nsEnvName);
    if (env === currentEnv) {
        return true;
    }
    switch (env.valueOf()) {
        case TrumpfEnvNames.PROD.valueOf():
        case TrumpfEnvNames.QA.valueOf():
            registerGlobal(env, nsEnvName);
            return true;
        default:
            return false;
    }
}

var configProd = {
    websiteBaseUrl: "https://www.trumpf.com",
    websitePaths: {
        home: "/",
        mytrumpf: "/mytrumpf",
        userProfile: "/?id=861",
    },
    authApiBaseUrl: "https://identity.trumpf.com/oauth2",
    iHubApiBaseUrl: "https://api-p.trumpf.com",
    iHubApiEndpoints: {
        selfService: "/selfservice/2.1",
    },
};

var configQA = {
    websiteBaseUrl: "https://www-q.trumpf.com",
    websitePaths: {
        home: "/",
        mytrumpf: "/mytrumpf",
        userProfile: "/?id=861",
    },
    authApiBaseUrl: "https://identity-s.trumpf.com/oauth2",
    iHubApiBaseUrl: "https://api-s.trumpf.com",
    iHubApiEndpoints: {
        selfService: "/selfservice/2.1",
    },
};

/**
 * @return {TrumpfConfig} configuration data
 */
function getConfig() {
    switch (getEnv()) {
        case TrumpfEnvNames.QA.valueOf():
            return configQA;
        case TrumpfEnvNames.PROD.valueOf():
        default:
            return configProd;
    }
}

class OAuth2Iframe {
    constructor(config, onStatus) {
        this._rpWindow = null;
        this._rpInterval = null;
        this.handleIframeLoad = () => {
            if (this.getRPWindow() !== null) {
                this.startPoll();
            }
        };
        this.handleIframeMessage = (e) => {
            if (e.origin !== this._opOrigin) {
                return;
            }
            switch (e.data) {
                case "unchanged":
                    this.callback(e.data);
                    break;
                case "changed":
                case "error":
                    this.stopPoll();
                    this.callback(e.data);
                    break;
            }
        };
        this.config = Object.assign({}, config);
        this._opOrigin = getUrlOrigin(this.config.checkSessionUri);
        this.callback = onStatus;
        this.initIframes();
    }
    initIframes() {
        // OP Iframe
        let opIframe = this.getOPIframe();
        if (opIframe !== null) {
            opIframe.removeEventListener("load", this.handleIframeLoad);
            opIframe.remove();
        }
        opIframe = document.createElement("iframe");
        opIframe.id = OP_IFRAME_ID;
        opIframe.src = `${this.config.checkSessionUri}?${getQueryString({
            client_id: this.config.clientId,
            redirect_uri: this.config.redirectUri,
        })}`;
        opIframe.addEventListener("load", this.handleIframeLoad);
        applyHiddenIframeStyles(opIframe);
        document.body.appendChild(opIframe);
        // RP Iframe
        let rpIframe = this.getRPIframe();
        if (rpIframe !== null) {
            rpIframe.removeEventListener("load", this.handleIframeLoad);
            rpIframe.remove();
        }
        rpIframe = document.createElement("iframe");
        rpIframe.id = RP_IFRAME_ID;
        rpIframe.srcdoc = getRPIframeSrcdoc(this.config);
        rpIframe.addEventListener("load", this.handleIframeLoad);
        applyHiddenIframeStyles(rpIframe);
        document.body.appendChild(rpIframe);
    }
    destroy() {
        this.stopPoll();
        const opIframe = this.getOPIframe();
        if (opIframe !== null) {
            opIframe.removeEventListener("load", this.handleIframeLoad);
            opIframe.remove();
        }
        const rpIframe = this.getRPIframe();
        if (rpIframe !== null) {
            rpIframe.removeEventListener("load", this.handleIframeLoad);
            rpIframe.remove();
        }
    }
    getOPIframe() {
        return document.querySelector(`iframe#${OP_IFRAME_ID}`);
    }
    getRPIframe() {
        return document.querySelector(`iframe#${RP_IFRAME_ID}`);
    }
    getRPWindow() {
        var _a;
        return ((_a = this.getRPIframe()) === null || _a === void 0 ? void 0 : _a.contentWindow) || null;
    }
    startPoll() {
        this.stopPoll();
        const rpWin = this.getRPWindow();
        if (rpWin !== null) {
            this._rpWindow = rpWin;
            this._rpWindow.addEventListener("message", this.handleIframeMessage, true);
            this._rpInterval = window.setInterval(() => {
                try {
                    rpWin.poll();
                }
                catch (_a) {
                    this.stopPoll();
                }
            }, Math.max(this.config.checkSessionInterval || RP_POLL_INTERVAL, 500));
        }
    }
    stopPoll() {
        if (this._rpInterval !== null) {
            window.clearInterval(this._rpInterval);
            this._rpInterval = null;
        }
        if (this._rpWindow !== null) {
            this._rpWindow.removeEventListener("message", this.handleIframeMessage);
            this._rpWindow = null;
        }
    }
}
/**
 * Set style attributes for hidden iframe
 * @param el
 */
const applyHiddenIframeStyles = (el) => {
    el.style.position = "absolute";
    el.style.border = "0 none transparent";
    el.style.left = "-1000px";
    el.style.top = "-1000px";
    el.style.width = "1px";
    el.style.height = "1px";
};
/**
 * Generate srcdoc for the RP iframe with poll function
 * @param config {{checkSessionUri: string, clientId: string, sessionState: string}}
 */
const getRPIframeSrcdoc = (config) => {
    const opIframeOrigin = getUrlOrigin(config.checkSessionUri);
    return RP_IFRAME_SRCDOC_TPL.replace("OP_IFRAME_MESSAGE", `${config.clientId} ${config.sessionState}`)
        .replace("OP_IFRAME_ORIGIN", opIframeOrigin)
        .replace("OP_IFRAME_ID", OP_IFRAME_ID);
};

/** @type string The localStorage namespace */
const lsNamespace = "trumpf.ux.oauth2Client";
class OAuth2Client {
    constructor(config) {
        this.observers = [];
        this._authClient = getAuthClient();
        this._authCode = null;
        this._authData = null;
        this._authError = null;
        this._sessionState = null;
        this._sessionIframe = null;
        this._status = OAuthStatusTypes.IDLE;
        this.sendTokenRequest = (data) => {
            const { issuer } = this.config;
            this._status = OAuthStatusTypes.PENDING;
            this._authError = null;
            return fetch(`${issuer}/token`, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                redirect: "follow",
                body: getQueryString(data),
            })
                .then((response) => response.json())
                .then((data) => {
                this._status = OAuthStatusTypes.IDLE;
                if (data.access_token) {
                    this.handleTokenResponse(data);
                }
                else if (data.error) {
                    this.handleErrorResponse(data);
                }
                this.notifyObservers();
                return data;
            });
        };
        this.handleErrorResponse = (authError) => {
            this.flushLocalStorageAuth();
            this.flushLocalStorageData();
            this._status = OAuthStatusTypes.ERROR;
            this._authError = authError;
            this._authData = null;
        };
        this.handleTokenResponse = (authData) => {
            this.flushLocalStorageAuth();
            this.flushLocalStorageData();
            this._status = OAuthStatusTypes.AUTHENTICATED;
            this._authCode = null;
            this._authData = Object.assign(Object.assign(Object.assign({}, this._authData), authData), { expires_at: Date.now() + authData.expires_in * 1000, redirect_uri: this._redirectUri || undefined, session_state: this._sessionState });
            localStorage.setItem(`${lsNamespace}.auth`, JSON.stringify(this._authData));
            this._authClient.setTokenData(authData);
            this.initSessionIframe();
        };
        this.revokeAuthentication = () => {
            this._authData = null;
            this._authError = null;
            this._status = OAuthStatusTypes.IDLE;
            this.destroySessionIframe();
            this.flushLocalStorageData();
            this.flushLocalStorageAuth();
        };
        this.getLocalStorageAuth = () => {
            const jsonStr = localStorage.getItem(`${lsNamespace}.auth`);
            if (jsonStr === null)
                return null;
            try {
                return JSON.parse(jsonStr);
            }
            catch (_a) {
                localStorage.removeItem(`${lsNamespace}.auth`);
                return null;
            }
        };
        this.getLocalStorageData = () => {
            const jsonStr = localStorage.getItem(`${lsNamespace}.data`);
            const data = Object.assign({ state: null, codeVerifier: null, redirectUri: null }, (jsonStr !== null ? JSON.parse(jsonStr) : {}));
            this._localStorageData = data;
            return data;
        };
        this.updateLocalStorageData = (data) => {
            this._localStorageData = data;
            const jsonStr = JSON.stringify(this._localStorageData, null, "");
            localStorage.setItem(`${lsNamespace}.data`, jsonStr);
            return this._localStorageData;
        };
        this.flushLocalStorageData = () => {
            localStorage.removeItem(`${lsNamespace}.data`);
        };
        this.flushLocalStorageAuth = () => {
            localStorage.removeItem(`${lsNamespace}.auth`);
        };
        this.createStateHash = () => {
            this.updateLocalStorageData(Object.assign(Object.assign({}, this._localStorageData), { state: Math.random().toString(36).slice(2) }));
            return this._localStorageData.state;
        };
        this.handleSessionIframeStatus = (status) => {
            if (status === "changed" &&
                this._status === OAuthStatusTypes.AUTHENTICATED) {
                this.deleteAccessToken();
            }
        };
        this.destroySessionIframe = () => {
            if (this._sessionIframe) {
                this._sessionIframe.destroy();
                this._sessionIframe = null;
            }
        };
        this.getSessionIframe = () => {
            return this._sessionIframe;
        };
        this.initSessionIframe = () => {
            const { checkSessionUri, clientId } = this.config;
            this.destroySessionIframe();
            if (this._sessionState === null ||
                this._redirectUri === null ||
                !checkSessionUri) {
                return;
            }
            this._sessionIframe = new OAuth2Iframe({
                checkSessionUri,
                clientId,
                redirectUri: this._redirectUri,
                sessionState: this._sessionState,
            }, this.handleSessionIframeStatus);
        };
        const { authApiBaseUrl } = getConfig();
        this._localStorageData = this.getLocalStorageData();
        this._authData = this.getLocalStorageAuth();
        this._redirectUri =
            this._localStorageData.redirectUri || config.redirectUri || null;
        this.config = Object.assign({ issuer: config.apiUrl || authApiBaseUrl, scope: "openid" }, config);
        this.init();
    }
    init() {
        // Read data from localStorage
        if (this._authData !== null &&
            typeof this._authData.redirect_uri === "string") {
            this._redirectUri = this._authData.redirect_uri;
        }
        // Check if request needs to be handled
        const state = getQueryParameter("state");
        if (state !== null && state === this._localStorageData.state) {
            // Handle query parameters
            const authCode = getQueryParameter("code");
            if (authCode !== null) {
                this._authCode = authCode;
                this._sessionState = getQueryParameter("session_state");
                this.requestTokenWithAuthCode();
                return;
            }
            if (getQueryParameter("logged_out") !== null) {
                this.deleteAccessToken();
                return;
            }
        }
        // Check if we have an active session
        if (this._authData !== null &&
            this._authData.access_token &&
            this._authData.session_state) {
            const expiresAt = this.getTokenExpiration();
            if (expiresAt <= 0 || expiresAt > new Date().getTime()) {
                this._sessionState = this._authData.session_state;
                this._status = OAuthStatusTypes.AUTHENTICATED;
                this.initSessionIframe();
                return;
            }
        }
        // reset state
        this._authData = null;
        this._authError = null;
        this._status = OAuthStatusTypes.IDLE;
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this);
            }
            catch (_a) {
                // Catch errors silently
            }
        });
    }
    subscribe(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
    getError() {
        return this._authError;
    }
    getStatus() {
        return this._status;
    }
    getAccessToken() {
        return this._authClient.getAccessToken();
    }
    /** @deprecated since version 2.5.0 */
    setAccessToken(token) {
        const prevToken = this.getAccessToken();
        if (this._authClient.setAccessToken(token)) {
            if (this.getAccessToken() !== prevToken) {
                this.notifyObservers();
            }
            return true;
        }
        return false;
    }
    deleteAccessToken() {
        const prevToken = this.getAccessToken();
        this._authClient.deleteAccessToken();
        this.revokeAuthentication();
        if (prevToken !== null) {
            this.notifyObservers();
        }
    }
    getTokenExpiration() {
        if (this._authData !== null &&
            typeof this._authData.expires_at === "number") {
            return this._authData.expires_at;
        }
        return 0;
    }
    /** @deprecated Use login(redirectUrl: string | undefined) instead */
    async requestAuthCode() {
        return this.login();
    }
    /**
     * Authorization code + PKCE
     * Step 1: request one-time authorization code
     */
    async login(loginRedirectUri) {
        const { issuer, clientId, scope } = this.config;
        const codeVerifier = getCodeVerifier();
        const codeChallenge = await getCodeChallenge(codeVerifier);
        const redirectUri = getUrlOrCurrent(loginRedirectUri || this.config.redirectUri);
        const data = {
            client_id: clientId,
            response_type: "code",
            redirect_uri: redirectUri,
            state: this.createStateHash(),
            scope: scope,
            code_challenge: codeChallenge,
            code_challenge_method: "S256",
        };
        this.updateLocalStorageData(Object.assign(Object.assign({}, this._localStorageData), { codeVerifier,
            redirectUri }));
        this.destroySessionIframe();
        window.top.location.assign(`${issuer}/authorize?${getQueryString(data)}`);
    }
    /**
     * Exchange one-time authorization code for access token
     */
    async requestTokenWithAuthCode() {
        const { clientId, scope } = this.config;
        const data = {
            grant_type: OAuthGrantTypes.AUTH_CODE,
            response_type: "token",
            code: this._authCode,
            redirect_uri: this._redirectUri,
            client_id: clientId,
            scope: scope,
            code_verifier: this._localStorageData.codeVerifier,
        };
        this._status = OAuthStatusTypes.PENDING;
        this.destroySessionIframe();
        return this.sendTokenRequest(data);
    }
    /**
     * Password Grant
     * @param {username:string,password:string} credentials
     */
    /** @deprecated loginWithCredentials will be removed in the next major version */
    async loginWithCredentials({ username, password, }) {
        const { clientId, clientSecret, scope } = this.config;
        const data = {
            client_id: clientId,
            client_secret: clientSecret,
            grant_type: OAuthGrantTypes.PASSWORD,
            scope: scope,
            username: username,
            password: password,
        };
        this._status = OAuthStatusTypes.PENDING;
        this.destroySessionIframe();
        return this.sendTokenRequest(data);
    }
    /**
     * Refresh token
     */
    async refreshToken() {
        const { clientId } = this.config;
        if (!this._authData || !this._authData.refresh_token) {
            throw new Error("No refresh_token");
        }
        this.destroySessionIframe();
        const data = {
            client_id: clientId,
            grant_type: OAuthGrantTypes.REFRESH_TOKEN,
            refresh_token: this._authData.refresh_token,
        };
        return this.sendTokenRequest(data);
    }
    async logout() {
        if (this._status !== OAuthStatusTypes.AUTHENTICATED) {
            this.deleteAccessToken();
            return;
        }
        const logoutBaseUrl = getBaseUrl(this.config.logoutUri);
        if (logoutBaseUrl === null) {
            this.deleteAccessToken();
            return;
        }
        const postLogoutRedirectUri = getUrlOrCurrent(this.config.postLogoutRedirectUri);
        const queryPrefix = postLogoutRedirectUri.indexOf("?") === -1 ? "?" : "&";
        const logoutUrl = `${logoutBaseUrl}?${getQueryString({
            prompt: "none",
            id_token_hint: this._authData.id_token,
            post_logout_redirect_uri: `${postLogoutRedirectUri}${queryPrefix}${getQueryString({
                logged_out: "",
                state: this.createStateHash(),
            })}`,
        })}`;
        window.top.location.assign(logoutUrl);
    }
}

const NAMESPACE = "trumpf.ux.errorDispatcher";
const DEFAULT_SCOPE = "global";
let subscriberIncrement = 0;
const createSubscriberId = () => `error-subscriber-${++subscriberIncrement}`;
class ErrorDispatcher {
    constructor() {
        this.subscribers = {};
        this.notifySubscribers = (error) => {
            Object.values(this.subscribers).forEach((handler) => handler(error));
        };
    }
    dispatchError(error) {
        this.notifySubscribers(error);
    }
    subscribe(handler) {
        const subscriberId = createSubscriberId();
        this.subscribers[subscriberId] = handler;
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        delete this.subscribers[subscriberId];
    }
}
const getErrorDispatcher = (scope) => {
    const ns = `${NAMESPACE}.${scope || DEFAULT_SCOPE}`;
    let dispatcher = getRegisteredGlobal(ns) || null;
    if (dispatcher === null) {
        dispatcher = new ErrorDispatcher();
        registerGlobal(dispatcher, ns);
    }
    return dispatcher;
};

/**
 * @param element any DOM Element
 * @returns Object of all attributes
 */
function getAttributes(element) {
    if (!element)
        return {};
    const nodeMap = element.attributes;
    const length = nodeMap.length;
    return Object.keys(nodeMap).reduce((props, current) => {
        try {
            const numCurrent = parseInt(current);
            if (numCurrent <= length) {
                const property = nodeMap[current];
                return Object.assign(Object.assign({}, props), { [property.name]: property.value });
            }
        }
        catch (err) {
            // nothing
        }
    }, {});
}

const getSvg = (width, height) => `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}" style="background: #e7e7e7">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="-22.4 -37.5 135 165">
            <path fill="#a1a1a1" d="M5.53 22.89h78.95v61.58H5.53zM12.47 21.31H8.58V9.1h-3V5.52h10V9.1h-3.11zM16.8 5.52h6c3.55 0 5.59 1.94 5.59 5.32 0 2.78-1.18 4.4-3.64 4.94l4.37 5.53h-4.87l-3.61-5.15v5.15H16.8zm5.55 8a2.17 2.17 0 002.16-2.33 1.89 1.89 0 00-1.87-2.16h-1.92v4.44zM41.73 15.38c0 4.32-1.91 6.33-6.08 6.33-2.43 0-4.21-.86-5.13-2.5a8.14 8.14 0 01-.71-3.94V5.52h3.89v9.82c0 1.83.62 2.58 2.14 2.58s2-.78 2-2.63V5.52h3.89zM43.64 5.52h5.2l3.18 10.64 3-10.64h5.2v15.79h-3.58V10.39L53.3 21.31h-2.87l-3.29-10.79v10.79h-3.5zM62.25 5.52h6.1a4.94 4.94 0 015.23 5.3 5.24 5.24 0 01-5.19 5.56h-2.26v4.93h-3.88zm5.55 7.24a1.75 1.75 0 001.84-1.79 1.75 1.75 0 00-2-1.83h-1.47v3.66zM74.8 5.52h9.64V9.1h-5.39v2.5h5.39v3.62h-5.39v6.09H74.8z"/>
        </svg>
    </svg>
`;
const convertToUrl = (input) => `data:image/svg+xml,${encodeURIComponent(input)
    .replace(/%20/g, " ")
    .replace(/%0A/g, "")
    .replace(/\s\s+/g, " ")
    .trim()}`;
/**
 * @param {number} width
 * @param {number} height
 * @return {string} a url containing the code for the placeholder gif with the specified dimensions
 */
const getImageUrlPlaceholder = (width, height) => convertToUrl(getSvg(width, height));

/*! formdata-polyfill. MIT License. Jimmy W?rting <https://jimmy.warting.se/opensource> */
(function(){var h;function l(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var m="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};
function n(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var q=n(this);function r(a,b){if(b)a:{var c=q;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e];}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&m(c,a,{configurable:!0,writable:!0,value:b});}}
r("Symbol",function(a){function b(f){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(f||"")+"_"+e++,f)}function c(f,g){this.A=f;m(this,"description",{configurable:!0,writable:!0,value:g});}if(a)return a;c.prototype.toString=function(){return this.A};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});
r("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=q[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&m(d.prototype,a,{configurable:!0,writable:!0,value:function(){return u(l(this))}});}return a});function u(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}
function v(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:l(a)}}var w;if("function"==typeof Object.setPrototypeOf)w=Object.setPrototypeOf;else {var y;a:{var z={a:!0},A={};try{A.__proto__=z;y=A.a;break a}catch(a){}y=!1;}w=y?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null;}var B=w;function C(){this.m=!1;this.j=null;this.v=void 0;this.h=1;this.u=this.C=0;this.l=null;}
function D(a){if(a.m)throw new TypeError("Generator is already running");a.m=!0;}C.prototype.o=function(a){this.v=a;};C.prototype.s=function(a){this.l={D:a,F:!0};this.h=this.C||this.u;};C.prototype.return=function(a){this.l={return:a};this.h=this.u;};function E(a,b){a.h=3;return {value:b}}function F(a){this.g=new C;this.G=a;}F.prototype.o=function(a){D(this.g);if(this.g.j)return G(this,this.g.j.next,a,this.g.o);this.g.o(a);return H(this)};
function I(a,b){D(a.g);var c=a.g.j;if(c)return G(a,"return"in c?c["return"]:function(d){return {value:d,done:!0}},b,a.g.return);a.g.return(b);return H(a)}F.prototype.s=function(a){D(this.g);if(this.g.j)return G(this,this.g.j["throw"],a,this.g.o);this.g.s(a);return H(this)};
function G(a,b,c,d){try{var e=b.call(a.g.j,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.g.m=!1,e;var f=e.value;}catch(g){return a.g.j=null,a.g.s(g),H(a)}a.g.j=null;d.call(a.g,f);return H(a)}function H(a){for(;a.g.h;)try{var b=a.G(a.g);if(b)return a.g.m=!1,{value:b.value,done:!1}}catch(c){a.g.v=void 0,a.g.s(c);}a.g.m=!1;if(a.g.l){b=a.g.l;a.g.l=null;if(b.F)throw b.D;return {value:b.return,done:!0}}return {value:void 0,done:!0}}
function J(a){this.next=function(b){return a.o(b)};this.throw=function(b){return a.s(b)};this.return=function(b){return I(a,b)};this[Symbol.iterator]=function(){return this};}function K(a,b){b=new J(new F(b));B&&a.prototype&&B(b,a.prototype);return b}function L(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return {value:b(f,a[f]),done:!1}}d=!0;return {done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}
r("Array.prototype.entries",function(a){return a?a:function(){return L(this,function(b,c){return [b,c]})}});
if("undefined"!==typeof Blob&&("undefined"===typeof FormData||!FormData.prototype.keys)){var M=function(a,b){for(var c=0;c<a.length;c++)b(a[c]);},N=function(a){return a.replace(/\r?\n|\r/g,"\r\n")},O=function(a,b,c){if(b instanceof Blob){c=void 0!==c?String(c+""):"string"===typeof b.name?b.name:"blob";if(b.name!==c||"[object Blob]"===Object.prototype.toString.call(b))b=new File([b],c);return [String(a),b]}return [String(a),String(b)]},P=function(a,b){if(a.length<b)throw new TypeError(b+" argument required, but only "+
a.length+" present.");},Q="object"===typeof globalThis?globalThis:"object"===typeof window?window:"object"===typeof self?self:this,R=Q.FormData,S=Q.XMLHttpRequest&&Q.XMLHttpRequest.prototype.send,T=Q.Request&&Q.fetch,U=Q.navigator&&Q.navigator.sendBeacon,V=Q.Element&&Q.Element.prototype,W=Q.Symbol&&Symbol.toStringTag;W&&(Blob.prototype[W]||(Blob.prototype[W]="Blob"),"File"in Q&&!File.prototype[W]&&(File.prototype[W]="File"));try{new File([],"");}catch(a){Q.File=function(b,c,d){b=new Blob(b,d||{});
Object.defineProperties(b,{name:{value:c},lastModified:{value:+(d&&void 0!==d.lastModified?new Date(d.lastModified):new Date)},toString:{value:function(){return "[object File]"}}});W&&Object.defineProperty(b,W,{value:"File"});return b};}var escape=function(a){return a.replace(/\n/g,"%0A").replace(/\r/g,"%0D").replace(/"/g,"%22")},X=function(a){this.i=[];var b=this;a&&M(a.elements,function(c){if(c.name&&!c.disabled&&"submit"!==c.type&&"button"!==c.type&&!c.matches("form fieldset[disabled] *"))if("file"===
c.type){var d=c.files&&c.files.length?c.files:[new File([],"",{type:"application/octet-stream"})];M(d,function(e){b.append(c.name,e);});}else "select-multiple"===c.type||"select-one"===c.type?M(c.options,function(e){!e.disabled&&e.selected&&b.append(c.name,e.value);}):"checkbox"===c.type||"radio"===c.type?c.checked&&b.append(c.name,c.value):(d="textarea"===c.type?N(c.value):c.value,b.append(c.name,d));});};h=X.prototype;h.append=function(a,b,c){P(arguments,2);this.i.push(O(a,b,c));};h.delete=function(a){P(arguments,
1);var b=[];a=String(a);M(this.i,function(c){c[0]!==a&&b.push(c);});this.i=b;};h.entries=function b(){var c,d=this;return K(b,function(e){1==e.h&&(c=0);if(3!=e.h)return c<d.i.length?e=E(e,d.i[c]):(e.h=0,e=void 0),e;c++;e.h=2;})};h.forEach=function(b,c){P(arguments,1);for(var d=v(this),e=d.next();!e.done;e=d.next()){var f=v(e.value);e=f.next().value;f=f.next().value;b.call(c,f,e,this);}};h.get=function(b){P(arguments,1);var c=this.i;b=String(b);for(var d=0;d<c.length;d++)if(c[d][0]===b)return c[d][1];
return null};h.getAll=function(b){P(arguments,1);var c=[];b=String(b);M(this.i,function(d){d[0]===b&&c.push(d[1]);});return c};h.has=function(b){P(arguments,1);b=String(b);for(var c=0;c<this.i.length;c++)if(this.i[c][0]===b)return !0;return !1};h.keys=function c(){var d=this,e,f,g,k,p;return K(c,function(t){1==t.h&&(e=v(d),f=e.next());if(3!=t.h){if(f.done){t.h=0;return}g=f.value;k=v(g);p=k.next().value;return E(t,p)}f=e.next();t.h=2;})};h.set=function(c,d,e){P(arguments,2);c=String(c);var f=[],g=O(c,
d,e),k=!0;M(this.i,function(p){p[0]===c?k&&(k=!f.push(g)):f.push(p);});k&&f.push(g);this.i=f;};h.values=function d(){var e=this,f,g,k,p,t;return K(d,function(x){1==x.h&&(f=v(e),g=f.next());if(3!=x.h){if(g.done){x.h=0;return}k=g.value;p=v(k);p.next();t=p.next().value;return E(x,t)}g=f.next();x.h=2;})};X.prototype._asNative=function(){for(var d=new R,e=v(this),f=e.next();!f.done;f=e.next()){var g=v(f.value);f=g.next().value;g=g.next().value;d.append(f,g);}return d};X.prototype._blob=function(){var d="----formdata-polyfill-"+
Math.random(),e=[],f="--"+d+'\r\nContent-Disposition: form-data; name="';this.forEach(function(g,k){return "string"==typeof g?e.push(f+escape(N(k))+('"\r\n\r\n'+N(g)+"\r\n")):e.push(f+escape(N(k))+('"; filename="'+escape(g.name)+'"\r\nContent-Type: '+(g.type||"application/octet-stream")+"\r\n\r\n"),g,"\r\n")});e.push("--"+d+"--");return new Blob(e,{type:"multipart/form-data; boundary="+d})};X.prototype[Symbol.iterator]=function(){return this.entries()};X.prototype.toString=function(){return "[object FormData]"};
V&&!V.matches&&(V.matches=V.matchesSelector||V.mozMatchesSelector||V.msMatchesSelector||V.oMatchesSelector||V.webkitMatchesSelector||function(d){d=(this.document||this.ownerDocument).querySelectorAll(d);for(var e=d.length;0<=--e&&d.item(e)!==this;);return -1<e});W&&(X.prototype[W]="FormData");if(S){var Y=Q.XMLHttpRequest.prototype.setRequestHeader;Q.XMLHttpRequest.prototype.setRequestHeader=function(d,e){Y.call(this,d,e);"content-type"===d.toLowerCase()&&(this.B=!0);};Q.XMLHttpRequest.prototype.send=
function(d){d instanceof X?(d=d._blob(),this.B||this.setRequestHeader("Content-Type",d.type),S.call(this,d)):S.call(this,d);};}T&&(Q.fetch=function(d,e){e&&e.body&&e.body instanceof X&&(e.body=e.body._blob());return T.call(this,d,e)});U&&(Q.navigator.sendBeacon=function(d,e){e instanceof X&&(e=e._asNative());return U.call(this,d,e)});Q.FormData=X;}})();

/**
 * Serialize Form to a type application/x-www-form-urlencoded string
 * via https://stackoverflow.com/questions/11661187/form-serialize-javascript-no-framework#answer-44033425
 */
const serializeForm = (formElement) => {
    if (formElement === null)
        return "";
    return Array.from(new FormData(formElement), (e) => e.map(encodeURIComponent).join("=")).join("&");
};

const isJsonString = (str) => {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
};

let subscriberIncrementId = 0;
/**
 * @class SharedStore
 * SharedStore only works with simple data that can be transformed into strings.
 * Objects are possible as long as JSON.stringify can handle it
 */
class SharedStore {
    constructor(storeName) {
        this.store = {};
        this.subscribers = {};
        this.subscriptions = {};
        this.notifySubscribers = (name, value, previousValue) => {
            if (!(name in this.subscriptions) || previousValue === value) {
                // this check only works for simple dataTypes!
                return;
            }
            this.subscriptions[name].forEach((id) => {
                this.subscribers[id]({
                    name,
                    value,
                });
            });
        };
        this.persistStore = () => {
            localStorage.setItem(this.name, JSON.stringify(this.store));
        };
        this.name = storeName;
        const storageItem = localStorage.getItem(this.name);
        if (storageItem !== null && isJsonString(storageItem)) {
            this.store = JSON.parse(storageItem);
        }
    }
    getValue(name) {
        return this.store[name];
    }
    setValue(name, value) {
        const previousValue = this.store[name];
        this.store[name] = value;
        this.notifySubscribers(name, value, previousValue);
        this.persistStore();
    }
    subscribe(names, callback) {
        const storeNames = Array.isArray(names) ? names : [names];
        const subscriberId = `store__${this.name}--${++subscriberIncrementId}`;
        this.subscribers[subscriberId] = callback;
        storeNames.forEach((name) => {
            this.subscriptions[name] = [
                ...(this.subscriptions[name] || []),
                subscriberId,
            ];
        });
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        delete this.subscribers[subscriberId];
        Object.keys(this.subscriptions).forEach((key) => {
            this.subscriptions[key] = this.subscriptions[key].filter((id) => id !== subscriberId);
        });
    }
}

/**
 * @param {string} name
 * @return {SharedStoreType}
 */
function getSharedStore(name) {
    if (!name) {
        throw new Error("sharedStore requires a name");
    }
    const storeFullName = `trumpf.ux.sharedStores.${name}`;
    const existingStore = getRegisteredGlobal(storeFullName);
    if (existingStore) {
        return existingStore;
    }
    const store = new SharedStore(storeFullName);
    registerGlobal(store, storeFullName);
    return store;
}

var SharedStoreNames;
(function (SharedStoreNames) {
    SharedStoreNames["GLOBAL"] = "global";
})(SharedStoreNames || (SharedStoreNames = {}));

/**
 * API request for fetching userData of an authenticated TRUMPF user.
 *
 * @param {string|undefined} token
 * @return {Promise<TrumpfUserData|null>}
 */
async function getTrumpfUser(token) {
    const accessToken = token !== undefined ? token : getAuthClient().getAccessToken();
    if (accessToken === null) {
        return null;
    }
    try {
        const config = getConfig();
        const result = await fetch(`${config.iHubApiBaseUrl}${config.iHubApiEndpoints.selfService}`, {
            method: "GET",
            keepalive: true,
            headers: {
                Accept: "application/json, text/plain, */*",
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return (await result.json());
    }
    catch (e) {
        return null;
    }
}

/**
 * Transforms the Trumpf API user data to the base user model.
 */
function transformTrumpfUserData(user) {
    const userEmail = user.emails && user.emails[0] ? user.emails[0].value || "" : "";
    const userName = user.userName || userEmail;
    return {
        displayName: userName,
        email: userEmail,
        locale: user.locale || "",
        role: user.roles && user.roles[0] ? user.roles[0] : "",
        userId: user.id || "",
        userName: userName,
    };
}

/**
 * The TrumpfUserClient is intended as a singleton instance.
 * It should only be instantiated once via the getTrumpfUserClient() function.
 */
class TrumpfUserClient {
    constructor() {
        this.userData = null;
        this.pendingRequest = false;
        this.observers = [];
        getAuthClient().subscribe(() => {
            this.getUserData(true);
        });
    }
    async requestUserData() {
        if (this.pendingRequest !== false) {
            return this.pendingRequest;
        }
        this.pendingRequest = getTrumpfUser();
        this.userData = await this.pendingRequest;
        this.notifyObservers();
        this.pendingRequest = false;
        return this.userData;
    }
    notifyObservers() {
        this.observers.forEach((observer) => {
            try {
                observer(this.userData);
            }
            catch (_a) {
                // Catch errors silently
            }
        });
    }
    async getUserData(reload) {
        return this.userData !== null && reload !== true
            ? this.userData
            : this.requestUserData();
    }
    getBaseUser() {
        if (this.userData !== null) {
            return transformTrumpfUserData(this.userData);
        }
        return null;
    }
    subscribe(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
        }
        return () => {
            this.unsubscribe(observer);
        };
    }
    unsubscribe(observer) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.observers.splice(index, 1);
        }
    }
}

const globalNamespace = "trumpf.ux.apiUserClient";
/**
 * @return {TrumpfUserClientInstance}
 */
function getTrumpfUserClient() {
    let client = getRegisteredGlobal(globalNamespace, window);
    if (client === undefined) {
        client = new TrumpfUserClient();
        registerGlobal(client, globalNamespace);
    }
    return client;
}

/** namespace for the global WindetFilterProvider */
const WIDGET_FILTER_PROVIDER_NAMESPACE = "trumpf.ux.widgetFilterProvider";
/** namespace for the global WindetRegistry */
const WIDGET_REGISTRY_NAMESPACE = "trumpf.ux.widgetRegistry";
/** scope name of the global WindetRegistry */
const WIDGET_REGISTRY_SCOPE_GLOBAL = "global";

class WidgetFilterProvider {
    constructor(name) {
        this._name = name;
        this._store = getSharedStore(`widgetFilterProvider.${this._name}`);
    }
    getFilter(filterName) {
        return this._store.getValue(filterName) || null;
    }
    setFilter(filterName, filterValue) {
        let filter = this.getFilter(filterName);
        if (filter !== null && filter.filterValue === filterValue) {
            return filter;
        }
        filter = {
            filterName,
            filterValue,
        };
        this._store.setValue(filterName, filter);
        return filter;
    }
    subscribe(filterName, callback) {
        const filterNames = Array.isArray(filterName)
            ? filterName
            : [filterName];
        return this._store.subscribe(filterNames, ({ value }) => {
            callback(value);
        });
    }
    unsubscribe(subscriberId) {
        return this._store.unsubscribe(subscriberId);
    }
}
/**
 * @param {string} name
 * @return {WidgetFilterProvider}
 */
function getWidgetFilterProvider(name = "global") {
    const ns = `${WIDGET_FILTER_PROVIDER_NAMESPACE}.${name}`;
    let provider = getRegisteredGlobal(ns);
    if (provider === undefined) {
        provider = new WidgetFilterProvider(name);
        registerGlobal(provider, ns);
    }
    return provider;
}

class WidgetRegistry {
    constructor() {
        this.widgets = {};
    }
    registerWidget(type, tagName, config) {
        this.widgets[type] = {
            type,
            tagName,
            config: config || {},
        };
    }
    getWidgetDefinition(type) {
        if (typeof this.widgets[type] !== "object") {
            throw Error(`getWidgetDefinition Error: no widget registered for type ${type}`);
        }
        return this.widgets[type];
    }
    getRegisteredWidgets() {
        return Object.keys(this.widgets).map((type) => this.widgets[type]);
    }
}
/**
 * Get the globally registered WidgetRegistry instance.
 * If no registry is registered yet, a new singleton instance
 * is created.
 * @param scope optional scope of the registry
 * @return {WidgetRegistryApi} the singleton instance
 */
function getWidgetRegistry(scope) {
    const scopeName = scope || WIDGET_REGISTRY_SCOPE_GLOBAL;
    const namespace = `${WIDGET_REGISTRY_NAMESPACE}.${scopeName}`;
    let registry = getRegisteredGlobal(namespace);
    if (registry === undefined) {
        registry = new WidgetRegistry();
        registerGlobal(registry, namespace);
    }
    return registry;
}
/**
 * Register a widget definition at the global WidgetRegistry.
 * @param {string} type
 * @param {string} tagName
 * @param {WidgetConfiguration} config
 */
function registerWidget(type, tagName, config) {
    return getWidgetRegistry().registerWidget(type, tagName, config);
}
/**
 * Retrieve a widget definition from the global WidgetRegistry.
 * @param {string} type
 * @return {WidgetDefinition}
 */
function getWidgetDefinition(type) {
    return getWidgetRegistry().getWidgetDefinition(type);
}

let widgetSettingSubscriptionIncrementId = 1;
class WidgetSettingProvider {
    constructor(config) {
        this.notifySubscribers = () => {
            const data = this._data;
            Object.values(this._subscriptions).forEach((callback) => {
                try {
                    callback(data);
                }
                catch (err) {
                    // Fail silently
                }
            });
        };
        this.handleWidgetSettings = (event) => {
            const { detail } = event;
            const { widgetAttributeName } = this;
            if (detail.name === widgetAttributeName &&
                detail.value !== this.serializeData()) {
                this.readWidgetAttribute();
            }
        };
        this._config = Object.assign({}, config);
        this._subscriptions = {};
        this._data = null;
        if (this.widgetAttributeName) {
            this.readWidgetAttribute();
            this.widgetElement.addEventListener("uxcWidgetSettings", this.handleWidgetSettings);
        }
    }
    get widgetElement() {
        return this._config.widgetElement;
    }
    get widgetAttributeName() {
        return this._config.widgetAttributeName || null;
    }
    getData() {
        return this._data;
    }
    setData(data) {
        if (data === this._data) {
            return;
        }
        this._data = data;
        this.updateWidgetAttribute();
        this.notifySubscribers();
    }
    subscribe(callback) {
        const subscriberId = `widget-setting-subscription--${++widgetSettingSubscriptionIncrementId}`;
        this._subscriptions[subscriberId] = callback;
        return subscriberId;
    }
    unsubscribe(subscriberId) {
        if (this._subscriptions[subscriberId]) {
            delete this._subscriptions[subscriberId];
        }
    }
    readWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" ||
            !(widgetElement instanceof HTMLElement)) {
            return;
        }
        this.setData(this.parseWidgetAttribute());
    }
    updateWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" ||
            !(widgetElement instanceof HTMLElement)) {
            return;
        }
        const oldValue = this.getWidgetAttributeValue();
        const newValue = this.serializeData();
        if (newValue !== oldValue) {
            widgetElement.setAttribute(widgetAttributeName, newValue);
            widgetElement.dispatchEvent(new CustomEvent("uxcWidgetSettings", {
                bubbles: true,
                cancelable: false,
                detail: {
                    name: widgetAttributeName,
                    value: newValue,
                },
            }));
        }
    }
    getWidgetAttributeValue() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" ||
            !(widgetElement instanceof HTMLElement)) {
            return "";
        }
        return widgetElement.getAttribute(widgetAttributeName) || "";
    }
    parseWidgetAttribute() {
        const { widgetElement, widgetAttributeName } = this._config;
        if (typeof widgetAttributeName !== "string" ||
            !(widgetElement instanceof HTMLElement)) {
            return null;
        }
        const value = this.getWidgetAttributeValue();
        if (!value || value.length === 0) {
            return null;
        }
        try {
            return JSON.parse(value);
        }
        catch (_a) {
            return null;
        }
    }
    serializeData() {
        if (this._data) {
            try {
                return JSON.stringify(this._data);
            }
            catch (_a) {
                return "";
            }
        }
        return "";
    }
}

class WidgetFilterSettingProvider extends WidgetSettingProvider {
    constructor({ widgetElement, widgetAttributeName = "filter", menuItems, }) {
        super({
            widgetElement,
            widgetAttributeName,
        });
        this._menuItems = Array.isArray(menuItems) ? menuItems : [];
    }
    getFilter() {
        return this.getData();
    }
    setFilter(value) {
        this.setData(value);
    }
    async getTags() {
        return [];
    }
    getMenuItems() {
        return this._menuItems;
    }
    selectMenuItem(_item) {
        // Override in implementation
    }
}

/***
 * @param element a stencil web-component
 * @param callback a function that will be called when the element is hydrated
 */
const waitForHydrated = (element, callback) => {
    if (element.classList.contains("hydrated")) {
        callback();
        return;
    }
    const observer = new MutationObserver((mutations) => _processMutations(mutations, element, callback, observer));
    observer.observe(element, { attributes: true });
};
/***
 * @private
 */
const _processMutations = (mutations, element, callback, observer) => mutations.forEach(({ attributeName }) => {
    if (attributeName == "class" &&
        element.classList.contains("hydrated")) {
        callback();
        observer.disconnect();
    }
});

export { AuthClient, AuthClientPersistenceOptions, ErrorDispatcher, OAuth2Client, OAuthGrantTypes, OAuthStatusTypes, SharedStoreNames, TrumpfUserClient, WidgetFilterSettingProvider, WidgetSettingProvider, convertToUrl, getAttributes, getAuthClient, getConfig, getEnv, getErrorDispatcher, getImageUrlPlaceholder, getRegisteredGlobal, getSharedStore, getSvg, getTrumpfUser, getTrumpfUserClient, getWidgetDefinition, getWidgetFilterProvider, getWidgetRegistry, registerGlobal, registerWidget, serializeForm, setEnv, transformTrumpfUserData, waitForHydrated };
//# sourceMappingURL=index.js.map
